<template>
  <div class="info-edit">
    <span class="info-title">编辑展项模板信息</span>
    <div class="info-body">
      <div class="info-left">
        <!-- 上传主图 -->
        <div class="main-image-body">
          <span class="main-title"
            >展项模板主图 <span class="import-icon">*</span></span
          >
          <span class="main-details">
            上传展项主图，用于展示在展项模板详情主页面页头轮播，最多可上传 6
            张，尺寸为1080*630px
          </span>
          <el-row :gutter="0">
            <el-col
              v-for="(i, index) in infoData.mainImageUrl"
              :key="index"
              :span="8"
            >
              <div @click="getImageTypeIndex(index)">
                <el-upload
                  :show-file-list="false"
                  action="/api/oss/upload"
                  :headers="{ Token: `${token}` }"
                  :max-size="512000"
                  :on-exceeded-size="onExceededSize"
                  :on-success="onSuccess"
                  :on-error="onError"
                >
                  <div class="mian-image" v-if="i.length > 0">
                    <img :src="i" alt="" />
                    <div
                      @click.stop="deleteMainEvent(index)"
                      class="delete-icon"
                    >
                      <i class="el-icon-error"></i>
                    </div>
                  </div>
                  <i v-else class="el-icon-plus"></i>
                </el-upload></div
            ></el-col>
          </el-row>
        </div>
        <!-- 模板名称 -->
        <div class="info-left-content">
          <el-input
            class="input-single input-title"
            v-model="infoData.name"
            placeholder="请输入展项模板名称"
          ></el-input>
          <el-input
            class="input-single input-details"
            v-model="infoData.remarks"
            placeholder="请输入展项简介"
          ></el-input>
        </div>
        <div class="details-content">
          <span class="details-title">详情介绍</span>
          <div class="details-upload">
            <el-upload
              :show-file-list="false"
              action="/api/oss/upload"
              :headers="{ Token: `${token}` }"
              :max-size="512000"
              :on-exceeded-size="onExceededSize"
              :on-success="onDetailsSuccess"
              :on-error="onError"
            >
              <div
                class="mian-image details-image"
                v-if="infoData.detailImageUrl.length > 0"
              >
                <img :src="infoData.detailImageUrl" alt="" />
              </div>
              <div v-else>
                <i class="el-icon-plus"></i>
                <span class="add-title">添加模板详情图</span>
                <div class="details-footer">
                  用于展示在展项模板介绍，宽为1080px，高度不限
                </div>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="info-right">
        <!-- 模板配置 -->
        <div class="info-set">
          <span class="set-title">模板设置</span>
          <div class="set-item">
            <span>模板分类</span>
            <el-select
              v-model="infoData.templateTypeId"
              size="small"
              placeholder="请选择展项类型"
              clearable
            >
              <el-option
                v-for="item in dataList"
                :key="item.id"
                :value="item.id"
                :label="item.typeName"
              ></el-option>
            </el-select>
          </div>
          <div class="set-item">
            <span>属性分类</span>
            <el-select
              v-model="infoData.attributionType"
              size="small"
              placeholder="请选择属性类型"
              clearable
            >
              <el-option
                v-for="item in attributeList"
                :key="item.key"
                :value="item.key"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
          <div class="set-item" v-if="infoData.attributionType == 2">
            <el-autocomplete
              style="width: 100%"
              v-model="attributeResult"
              :fetch-suggestions="querySearchAsync"
              @select="handleSelect"
              placeholder="请输入手机号码"
            >
              <template slot="append">
                <el-button
                  class="add-mobile"
                  @click="addattributionEvent"
                  type="primary"
                  >添加</el-button
                >
              </template></el-autocomplete
            >
          </div>
          <div class="set-item" v-if="mobileList.length > 0">
            <div class="mobile-content">
              <div
                class="mobile-item"
                v-for="(i, index) in mobileList"
                :key="i.id"
              >
                <span>{{ i.value }}</span>
                <i
                  @click="deleteMobileEvent(index)"
                  class="el-icon-circle-close delete-icon"
                ></i>
              </div>
            </div>
          </div>
          <div class="set-item">
            <span>模板价格</span>
            <div class="set-body">
              <div class="item-tab">
                <div
                  v-for="(i, index) in tabList"
                  :class="[
                    setActive == index ? 'set-active' : 'set-old',
                    'set-single',
                  ]"
                  :key="index"
                  @click="tabEvent(index)"
                >
                  {{ i.name }}
                </div>
              </div>
              <div class="set-add">
                <i
                  v-if="setActive == 0"
                  @click="addEvent"
                  class="el-icon-circle-plus-outline"
                ></i>
              </div>
            </div>
          </div>
          <div v-if="setActive == 0">
            <div class="set-item set-other">
              <!-- <span class="price-title">会员价格</span> -->
              <span class="price-title">普通价格</span>
              <div class="price-details">
                ( 按照最终销售总价，模板的作者将获得{{ scaleValue || 0 }}%的收益
                )
              </div>
            </div>
            <div
              v-for="(i, index) in infoData.priceList"
              class="set-item set-price"
              :key="index"
            >
              <!-- <el-input size="small" placeholder="请输入价格" v-model="input1">
              <template slot="prepend">¥</template>
            </el-input> -->
              <el-input
                size="small"
                placeholder="请输入价格"
                v-model="i.amount"
              >
                <template slot="prepend">¥</template>
              </el-input>
              <el-select
                size="small"
                v-model="i.serviceLife"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in timeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <div @click="deleteEvent(index)" class="set-add">
                <i class="el-icon-remove-outline"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="template-cover">
          <span class="cover-title">模板封面</span>
          <div class="template-single cover-content">
            <el-upload
              :show-file-list="false"
              action="/api/oss/upload"
              :headers="{ Token: `${token}` }"
              :max-size="512000"
              :on-exceeded-size="onExceededSize"
              :on-success="onCoverSuccess"
              :on-error="onError"
            >
              <div
                class="mian-image details-image"
                v-if="infoData.coverImageUrl.length > 0"
              >
                <img :src="infoData.coverImageUrl" alt="" />
              </div>
              <div v-else>
                <i class="el-icon-plus"></i>
                <span class="add-title">添加主图</span>
              </div>
            </el-upload>
          </div>
          <div class="tip-content">
            <img src="@/common/images/infoEdit/icon_02.png" />
            <span>封面会展示在线下馆某某XXX显示屏上，尺寸为1920*1080</span>
          </div>
        </div>
        <div class="template-cover">
          <span class="cover-title">模板预览</span>
          <!-- <div class="set-item">
            <span>预览地址</span>
            <el-input
              v-model="infoData.previewAddress"
              placeholder="请输入模板预览地址"
            ></el-input>
          </div> -->
          <div class="template-single">
            <el-upload
              :show-file-list="false"
              action="/api/oss/upload"
              :headers="{ Token: `${token}` }"
              :max-size="512000"
              :on-exceeded-size="onExceededSize"
              :on-success="onPreviewSuccess"
              :on-error="onError"
            >
              <div
                class="mian-image preview-image"
                v-if="infoData.previewUrl.length > 0"
              >
                <img :src="infoData.previewUrl" alt="" />
              </div>
              <div v-else>
                <i class="el-icon-plus"></i>
                <span class="add-title">添加主图</span>
              </div>
            </el-upload>
          </div>
          <div class="tip-content">
            <img src="@/common/images/infoEdit/icon_02.png" />
            <span>支持视频、图片等预览文件</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-center">
      <el-button type="info" @click.stop.prevent="close">取 消</el-button>
      <el-button type="primary" @click.stop.prevent="save">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
  },
  data() {
    return {
      active: 1,
      setActive: 0,
      input: "",
      mainImageType: 0,
      infoData: {
        name: "",
        remarks: "",
        chargeMethod: 2,
        detailImageUrl: "",
        coverImageUrl: "",
        previewUrl: "",
        templateTypeId: "",
        attributionType: 1,
        attributionUserIds: [],
        mainImageUrl: ["", "", "", "", "", ""],
        priceList: [],
        previewAddress: `${process.env.VUE_APP_PREVIEW_URL}`,
        formatType: 2,
        unityPackageUrl: "",
        webglUrl: "",
        sourceType: 5,
      },
      mobileList: [],
      timeout: null,
      selectData: {},
      attributeResult: "",
      dataList: [],
      timeList: [
        {
          name: "1个月",
          id: 1,
        },
        {
          name: "3个月",
          id: 3,
        },
        {
          name: "6个月",
          id: 6,
        },
        {
          name: "12个月",
          id: 12,
        },
        {
          name: "24个月",
          id: 24,
        },
      ],
      attributeList: [
        {
          key: 1,
          name: "公共模板",
        },
        // {
        //   key: 2,
        //   name: "专属模板",
        // },
      ],
      scaleValue: "",
      tabList: [
        {
          key: 0,
          name: "收费",
        },
        // {
        //   key: 1,
        //   name: "免费",
        // },
      ],
    };
  },

  watch: {
    infoData: {
      handler(newVal) {
        this.$emit("getInfoData", newVal);
      },
      deep: true,
    },
  },
  computed: {
    token() {
      return this.$store.getters.authorization;
    },
  },
  created() {
    this.getList();
    this.getIncomeScale();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      if (!this.infoData.name) {
        this.$message.error("模板名称必填");
        return;
      }
      if (!this.infoData.templateTypeId) {
        this.$message.error("请选择模板类型");
        return;
      }
      let hasMainImageUrl = false;
      this.infoData.mainImageUrl.map((i) => i && (hasMainImageUrl = true));
      if (!hasMainImageUrl) {
        this.$message.error("请上传模板主图");
        return;
      }
      this.$emit("save", this.infoData);
    },
    addattributionEvent() {
      if (Object.keys(this.selectData).length == 0) return;
      let isAdd = this.mobileList.some((i) => i.id == this.selectData.id);

      if (isAdd) return this.$message.warning("请勿重复添加");
      this.infoData.attributionUserIds.push(this.selectData.id);
      this.mobileList.push(this.selectData);
      this.attributeResult = "";
      this.selectData = {};
    },
    deleteMobileEvent(index) {
      this.infoData.attributionUserIds.splice(index, 1);
      this.mobileList.splice(index, 1);
    },
    querySearchAsync(queryString, callBack) {
      let nicknameList = [];
      this.$api.attributePage({ keyWord: queryString }).then((res) => {
        if (res.length == 0) {
          nicknameList.push({
            value: "无匹配结果",
            id: -1,
          });
          callBack(nicknameList);
        } else {
          for (let i = 0; i < res.length; i++) {
            nicknameList.push({
              value: res[i].mobile,
              id: res[i].id,
            });
          }
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            callBack(nicknameList);
          }, 500);
        }
      });
    },
    handleSelect(e) {
      this.selectData = e;
    },
    deepCopy(obj) {
      if (typeof obj !== "object" || obj === null) {
        return obj;
      }
      let copy = Array.isArray(obj) ? [] : {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = this.deepCopy(obj[key]);
        }
      }

      return copy;
    },
    async infoInit() {
      const { data } = await this.$axios.get(
        `/exhibitionItemsTemplate/getInfoById/?id=${this.id}`
      );
      // let data = this.deepCopy(this.rowData);
      let _arr = data.mainImageUrl.split(",");
      let mergedArr = this.infoData.mainImageUrl.map((url, index) => {
        return url !== "" ? url : _arr[index] ? _arr[index] : "";
      });
      this.infoData.id = this.id;
      this.infoData.name = data.name;
      this.infoData.chargeMethod = data.chargeMethod;
      this.infoData.detailImageUrl = data.detailImageUrl;
      this.infoData.coverImageUrl = data.coverImageUrl;
      this.infoData.previewUrl = data.previewUrl;
      this.infoData.templateTypeId = data.templateTypeId;
      this.infoData.attributionType = data.attributionType;
      this.mobileList = data.attributionUserList || [];
      this.infoData.attributionUserIds = data.attributionUserIds || [];
      this.infoData.formatType = data.formatType || 1;
      this.infoData.unityPackageUrl = data.unityPackageUrl || "";
      this.infoData.webglUrl = data.webglUrl || "";
      this.infoData.mainImageUrl = mergedArr;
      this.infoData.priceList = data.priceList ? data.priceList : [];
      this.infoData.remarks = data.remarks;
      this.infoData.previewAddress = data.previewAddress;

      if (data.code) {
        this.infoData["code"] = data.code;
        this.infoData["id"] = data.id;
        this.infoData["sourceType"] = data.sourceType;
        this.infoData["sourceId"] = data.sourceId;
      }
    },
    async getIncomeScale() {
      const { data } = await this.$axios.get("/open/getIncomeScale", {
        typeId: 2,
      });
      this.scaleValue = parseInt(data.scale);
    },
    async getList() {
      const { data } = await this.$axios.get(
        "/exhibitionItemsTemplateType/queryAll"
      );
      this.dataList = data;
      this.id && this.infoInit();
    },
    addEvent() {
      let obj = {
        amount: 0,
        serviceLife: 1,
      };
      this.infoData.priceList.push(obj);
    },
    deleteEvent(index) {
      this.infoData.priceList.splice(index, 1);
    },
    getImageTypeIndex(index) {
      this.mainImageType = index;
    },
    deleteMainEvent(index) {
      this.$set(this.infoData.mainImageUrl, index, "");
    },
    // 文件上传成功回调
    onSuccess(response) {
      let { data } = response;
      this.$set(this.infoData.mainImageUrl, this.mainImageType, data);
    },
    onDetailsSuccess(response) {
      let { data } = response;
      this.infoData.detailImageUrl = data;
    },
    onCoverSuccess(response) {
      let { data } = response;
      this.infoData.coverImageUrl = data;
    },
    onPreviewSuccess(response) {
      let { data } = response;
      this.infoData.previewUrl = data;
    },
    onUnitySuccess(response) {
      let { data } = response;
      this.infoData.unityPackageUrl = data;
    },
    onWebSuccess(response) {
      let { data } = response;
      this.infoData.webglUrl = data;
    },
    onExceededSize() {
      this.$message.error("附件文件上传大小最大不能超过500M");
    },
    // 文件上传失败的回调
    onError() {
      this.$message.error("服务异常，文件上传失败");
    },
    tabEvent(index) {
      this.infoData.chargeMethod = index == 0 ? 2 : 1;
      this.setActive = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.nfo-title {
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
}
.footer-center {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-body {
  display: flex;
  justify-content: space-between;
  .info-left {
    width: 840px;
    display: flex;
    flex-direction: column;
    .main-image-body {
      padding: 30px;
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      background: #141d3d;
      .main-title {
        font-size: 15px;
        color: #ffffff;
        display: flex;
        align-items: center;
      }
      .main-details {
        display: block;
        margin-top: 11px;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .details-content {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      .details-title {
        font-size: 16px;
        color: #ffffff;
      }
      .details-upload {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        div {
          width: 100%;
        }
        .add-title {
          width: 100%;
          display: block;
          text-align: center;
          line-height: 20px;
          margin-top: 22px;
          font-size: 15px;
          color: #93a2d8;
        }
        .details-footer {
          width: 100%;
          display: block;
          text-align: center;
          line-height: 20px;
          margin-top: 22px;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
  .info-right {
    width: 520px;
    .info-set {
      display: flex;
      flex-direction: column;
      padding: 21px;
      background: #141d3d;
      border-radius: 6px;
      .set-title {
        margin-bottom: 24px;
        font-size: 18px;
        color: #ffffff;
      }
      .set-add {
        font-size: 28px;
        cursor: pointer;
        margin-left: 10px;
      }
      .set-price {
        justify-content: space-around;
        align-items: center;
      }
      .set-other {
        margin-bottom: 10px !important;
      }
    }
    .set-item {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      .price-title {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        margin-right: -40px;
      }
      .price-details {
        font-size: 12px;
        color: #fff;
      }
      span {
        display: block;
        width: 100px;
        font-size: 16px;
      }
      .set-body {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .item-tab {
          display: flex;
          align-items: center;
          .set-single {
            width: 53px;
            height: 32px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 16px;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 29px;
            margin-right: 12px;
            cursor: pointer;
          }
          .set-active {
            border: 1px solid #ffffff;
          }
          .set-old {
            color: rgba(255, 255, 255, 0.6);
            border: 1px solid rgba(255, 255, 255, 0);
          }
        }
      }
    }
    .template-cover {
      display: flex;
      flex-direction: column;
      margin: 12px 0;
      padding: 21px 24px;
      background: #141d3d;
      border-radius: 0px 0px 4px 4px;
      .cover-title {
        font-size: 18px;
        font-weight: 500;
      }
      .tip-content {
        display: flex;
        align-items: center;
        margin-top: 20px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
        span {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
}
.template-single {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  div {
    width: 100%;
  }
  .add-title {
    width: 100%;
    display: block;
    text-align: center;
    line-height: 20px;
    margin-top: 12px;
    font-size: 15px;
    color: #93a2d8;
  }
}
.import-icon {
  color: #ff0000 !important;
  font-size: 16px;
  margin: 10px 0 0 5px;
}
::v-deep .el-upload {
  width: 100%;
  background: #141d3d;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.details-upload ::v-deep .el-upload {
  height: 350px !important;
}
.cover-content ::v-deep .el-upload {
  background: rgba(255, 255, 255, 0.1);
  height: 330px !important;
}
.template-single ::v-deep .el-upload {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  height: 196px;
  flex-direction: column;
  margin: 10px 0;
}
::v-deep .el-col {
  display: flex;
  justify-content: center;
  margin: 28px 0;
}
.mian-image {
  width: 100%;
  height: 126px;
  // overflow: hidden;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }
  .delete-icon {
    position: absolute;
    right: -10px;
    top: -20px;
    font-size: 30px;
  }
}
.details-image {
  height: 350px;
}
.preview-image {
  height: 196px;
}
.main-image-body ::v-deep .el-upload {
  width: 230px;
  height: 126px;
  background: #2b3450;
  border-radius: 4px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-title ::v-deep .el-input__inner {
  font-size: 32px;
  font-weight: 500;
  margin-top: 23px;
  padding: 23px 0 43px;
}
.input-single ::v-deep .el-input__inner {
  border: none;
  background: #2a3354 !important;
  border-radius: 0;
  border-bottom: 1px solid rgba(151, 151, 151, 0.4) !important;
}

.input-details ::v-deep .el-input__inner {
  margin-top: 10px;
  font-size: 16px;
  padding: 13px 0 23px;
}
.set-price ::v-deep .el-input-group__prepend {
  background: #3d4563;
  border: none;
  padding: 0 0 0 10px;
}
.set-price ::v-deep .el-input__inner {
  //   width: 120px;
  flex: 1;
  padding: 0 10px;
}
.set-price ::v-deep .el-input {
  flex: 1;
  padding: 0 10px;
}
::v-deep .el-icon-plus {
  color: #fff;
  font-size: 24px;
}
.add-mobile {
  cursor: pointer;
}
::v-deep .el-input-group__append {
  background: #141d3d;
  border: 1px solid #3d4563;
}
.mobile-content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background: #3d4563;
  padding: 10px;
  .mobile-item {
    margin: 0 10px 10px 0;
    background: #141d3d;
    padding: 5px 15px;
    border-radius: 5px;
    position: relative;
    .delete-icon {
      position: absolute;
      right: -5%;
      top: 0;
      font-size: 20px;
      cursor: pointer;
    }
  }
}

//
</style>
